import React, { useState, useCallback } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { Button, Text, Textarea, Radios, Spacer, Modal, Flexer } from '@ontruck/orc';

import { LOG_REASONS } from 'modules/log/log-reasons';
import { isCancellationLogOpened, getCancellationLog } from 'redux/modules/log/selectors';
import { createCancellationLog } from 'redux/modules/log/effects';
import tlogs_es from 'modules/log/t-logs_es';
import { StyledRadios } from './styled';
import t_logs from '../log/t-logs';
import { useSelector } from 'react-redux';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';
import { intlConfig } from 'intl/settings';

const t = {
  tab1: "It's a different reason",
  tab2: 'Go back',
  save: 'Save',
  comments_title: 'Comments',
  placehodler: 'Write what happened',
};

const reasonsInfo = {
  REQUESTED_BY_SHIPPER:
    'The shipper has proactively requested the cancellation and it’s not because they created a duplicate. Explain the reasons provided by the shipper in the comments field.',
  LOAD_NOT_READY:
    'The driver has arrived in time but the load or the paperwork are not ready. If the shipper requests to cancel because the load is not ready but the job hasn’t started yet, you must select “Requested by shipper.”',
  DRIVER_LATE_FOR_PICKUP:
    'The driver is running late to pickup and the shipper has requested to cancel the order after being informed.',
  DRIVER_NOT_FOUND: 'We haven’t been able to find a driver for this job.',
  DUPLICATED_ORDER:
    'Either the shipper or we created an order with mistakes and then created a new one correcting the mistakes.',
  LOAD_IS_NOT_WHAT_SHIPPER_SAID:
    'The load is not palletized or any of the details are wrong: date, hours, number of pallets, types of pallets, height, weight, extras, etc.',
  EXCEPTION_IN_RECURRING_ORDER: 'Cancellation of an instance of a recurring order.',
  REASON_OTHER:
    'Only use if the cancellation reason is not among the other options. Provide as many details as you can in the comments field.',
};

const enhance = compose(
  connect(
    (state) => ({
      cancellationLogOpened: isCancellationLogOpened(state),
      cancellationLog: getCancellationLog(state),
    }),
    { createCancellationLog }
  )
);

const CancellationReasons = ({
  createCancellationLog = () => {
    /*noop*/
  },
  cancellationLogOpened,
  cancellationLog,
}) => {
  const { action, shipperOrderId } = cancellationLog || {};

  const [reason, setReason] = useState('');
  const [comment, setComment] = useState('');

  const handleChangeReason = useCallback(
    (e, { value }) => {
      setReason(value);
    },
    [setReason]
  );

  const handleChangeComment = useCallback(
    (e, { value }) => {
      setComment(value);
    },
    [setComment]
  );

  const handleSubmit = useCallback(() => {
    createCancellationLog({ shipperOrderId, action, reason, comment });
  }, [createCancellationLog, shipperOrderId, action, reason, comment]);

  const isCancellationReasonsEnabled = useSelector((store) =>
    getSpecificClientConfig(store, constants.CANCELLATION_REASONS)
  );
  if (!cancellationLogOpened || !isCancellationReasonsEnabled) {
    return null;
  }

  const logs_messages = intlConfig.default.locale === 'es' ? tlogs_es : t_logs;
  const reasonsText = logs_messages.reasons[action] || {};

  const reasons = LOG_REASONS[action];

  return (
    <Modal
      show
      size="L"
      allowClose={false}
      closeButton={false}
      onTop
      headerComponent={logs_messages.titles[action]}
    >
      <Flexer.Parent justifyContent="space-around">
        <Radios
          girded
          legend={''}
          name="reasons"
          size="XLsmall"
          items={reasons.slice(0, 9).map((reason) => ({
            value: reason,
            label: reasonsText[reason] || reason,
            info: reasonsInfo[reason] || '',
          }))}
          value={reason}
          fieldsetAs={StyledRadios}
          onChange={handleChangeReason}
        />
      </Flexer.Parent>

      <Spacer mBottom="M" mTop="M">
        <Text text={t.comments_title} display="block" weight="bold" />
        <Textarea
          disabled={reason === ''}
          fullWidth
          value={comment}
          labelType="hidden"
          placeholder={t.placeholder}
          onChange={handleChangeComment}
          height={'100px'}
          width={'100%'}
        />
      </Spacer>
      <Spacer>
        <Button fullWidth onClick={handleSubmit} disabled={!reason} text={t.save} />
      </Spacer>
    </Modal>
  );
};

export default enhance(CancellationReasons);
